__turbopack_context__.v({
  "card": "styles-module__gS2RIa__card",
  "cardAddress": "styles-module__gS2RIa__cardAddress",
  "cardBody": "styles-module__gS2RIa__cardBody",
  "cardImage": "styles-module__gS2RIa__cardImage",
  "cardPrice": "styles-module__gS2RIa__cardPrice",
  "cardPriceBlock": "styles-module__gS2RIa__cardPriceBlock",
  "cardPriceSmall": "styles-module__gS2RIa__cardPriceSmall",
  "cardText": "styles-module__gS2RIa__cardText",
  "cardTextShort": "styles-module__gS2RIa__cardTextShort",
  "cardTitle": "styles-module__gS2RIa__cardTitle",
  "content": "styles-module__gS2RIa__content",
  "filterBlock": "styles-module__gS2RIa__filterBlock",
  "filterInput": "styles-module__gS2RIa__filterInput",
  "filterInputRow": "styles-module__gS2RIa__filterInputRow",
  "filterLabel": "styles-module__gS2RIa__filterLabel",
  "filters": "styles-module__gS2RIa__filters",
  "filtersTitle": "styles-module__gS2RIa__filtersTitle",
  "list": "styles-module__gS2RIa__list",
  "pageDot": "styles-module__gS2RIa__pageDot",
  "pagination": "styles-module__gS2RIa__pagination",
  "shimmer": "styles-module__gS2RIa__shimmer",
  "wrap": "styles-module__gS2RIa__wrap",
});
